module.exports = __webpack_public_path__ + "img/tran.3a1fb30c.png";